//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Design Right Component File
//  * @description -   This file renders the html and functionality that renders at right panel when design tab is selected.
<template>
  <div class="col-md-3 p-0 col-xs-12 survey_colume_3">
    <div class="colume_3_build sticky_bar">
      <img src="../../assets/images/bulb_img.png" alt="blub image" class="img-responsive">

      <div class="build_text">
        <h3>building a form is easy!</h3>
        <span>follow three simple steps:</span>

        <ul class="build_staps">
          <li>
            <i class="fa fa-check-square-o" aria-hidden="true"></i>choose setting
          </li>
          <li>
            <i class="fa fa-check-square-o" aria-hidden="true"></i>decide on design
          </li>
          <li>
            <i class="fa fa-square-o" aria-hidden="true"></i>create your questions
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "rightdesign",
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/rightdesign.vue